import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnUG: CultureInfo = {
  name: 'en-UG',
  displayName: 'English (Uganda)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-UG',
  parent: CultureInfoEn
};
